/**
 * LabsiteOnlineFormConfigurations
 */
export class LabsiteOnlineFormConfigurations {
    constructor(public fileId: string, public fileName: string, public fileExtension: string) { }
}